<template>
  <router-view></router-view>
  <GlobalLoader />
</template>

<script>
import storageService from "@/services/storage.service";
import { revokeSession } from "@/services/api";
import GlobalLoader from "@/components/GlobalLoader.vue";

export default {
  name: "App",
  components: { GlobalLoader },
  data() {
    return {
      inactivityTimeout: null,
      INACTIVITY_LIMIT: 15 * 60 * 1000, // 15 minutes
    };
  },
  mounted() {
    this.setupInactivityListener();
  },
  beforeUnmount() {
    this.cleanupInactivityListener();
  },
  methods: {
    setupInactivityListener() {
      const events = [
        "mousemove",
        "mousedown",
        "keydown",
        "touchstart",
        "scroll",
      ];
      this.resetTimer = () => {
        if (this.inactivityTimeout) {
          clearTimeout(this.inactivityTimeout);
        }
        const token = storageService.getItem("accessToken");
        if (token) {
          this.inactivityTimeout = setTimeout(() => {
            this.handleAutoLogout();
          }, this.INACTIVITY_LIMIT);
        }
      };

      events.forEach((evt) => {
        window.addEventListener(evt, this.resetTimer, { passive: true });
      });

      this.resetTimer();
    },
    cleanupInactivityListener() {
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
      }
    },
    async handleAutoLogout() {
      const token = storageService.getItem("accessToken");
      const userType = storageService.getItem("userType");
      if (!token) return;

      await revokeSession();
      storageService.clear();

      if (
        userType === "admin" ||
        userType === "super_user" ||
        userType === "staff" ||
        userType === "verification officer"
      ) {
        this.$router.push("/staff_login");
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>